import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "../App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import InterestForm from "./components/InterestForm";
import ContractPage from "./components/ContractPage";
import { Toaster } from "../components/ui/toaster";
import { apiService } from "./services/api";

export default function PrismApp() {
  useEffect(() => {
    const check = async () => {
      try {
        const response = await apiService.healthCheck();
        console.log("API Status:", response);
      } catch (e) {
        console.error("API health check failed:", e.message);
      }
    };
    check();
  }, []);

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="apply" element={<InterestForm />} />
          <Route path="contract" element={<ContractPage />} />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}